/** The maximum number of results returned by the Search service. */
export const maxResultsCount = 10000;
